import {useRef} from "react";
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";
import {
    IHomeMatchPreferencesWizardMapActions,
    useHomeMatchPreferencesWizardLocationMap
} from "../../hooks/preferences/use_home_match_preferences_wizard_location_map";
import {HomeMatchUserPreferencesLocation} from "../home_match_user_preferences/HomeMatchUserPreferencesLocation";
import {HomeMatchUserPreferencesLocationPreview} from "../home_match_user_preferences/HomeMatchUserPreferencesLocationPreview";

const {LOCATION_LABEL, LOCATION_NEXT_PLACEHOLDER, LOCATION_PLACEHOLDER} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;
const WIZARD_MAP_HEIGHT = 250;

interface IProps {
    hideLabel?: boolean;
    isMapOpen: boolean;
    onMapActiveChange: (isMapActive: boolean) => void;
    onRegisterMapActions: (actions: IHomeMatchPreferencesWizardMapActions | null) => void;
}

export const HomeMatchPreferencesWizardLocationStep = (props: IProps) => {
    const {hideLabel = false, isMapOpen, onMapActiveChange, onRegisterMapActions} = props;
    const {isMobile} = useUserDevice();
    const stepRef = useRef<HTMLDivElement>(null);
    const {coverStyle, handleUpdateRegionsByLocationPreview, openMap, regions} = useHomeMatchPreferencesWizardLocationMap({
        isMapOpen,
        onMapActiveChange,
        onRegisterMapActions,
        stepRef
    });

    return (
        <div className={cx(stepStyle, isMobile && stepMotionStyle)} ref={stepRef} style={coverStyle}>
            {!hideLabel &&
                (isMobile ? (
                    <div className={cx(labelSlotStyle, isMapOpen && labelSlotHiddenStyle)}>
                        <Text className={labelTextStyle} color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                            {LOCATION_LABEL}
                        </Text>
                    </div>
                ) : (
                    !isMapOpen && (
                        <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                            {LOCATION_LABEL}
                        </Text>
                    )
                ))}

            <HomeMatchUserPreferencesLocation
                hideIcons
                name="regions"
                nextPlaceholder={LOCATION_NEXT_PLACEHOLDER}
                onFocus={openMap}
                placeholder={LOCATION_PLACEHOLDER}
            />

            {isMapOpen && (
                <HomeMatchUserPreferencesLocationPreview
                    mapHeight={WIZARD_MAP_HEIGHT}
                    onUpdateRegions={handleUpdateRegionsByLocationPreview}
                    selectedRegions={regions}
                />
            )}
        </div>
    );
};

const coverMotion = css.raw({
    transitionDuration: "220ms",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",

    "@media (prefers-reduced-motion: reduce)": {
        transitionDuration: "0s"
    }
});

const stepStyle = css({
    backgroundColor: "var(--colors-white)",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    position: "relative",
    width: "100%",
    zIndex: "var(--zIndex-base)",

    md: {
        backgroundColor: "transparent",
        zIndex: "auto"
    }
});

const stepMotionStyle = css(coverMotion, {
    transitionProperty: "transform, margin-bottom"
});

const labelSlotStyle = css(coverMotion, {
    display: "grid",
    gridTemplateRows: "1fr",
    minHeight: 0,
    transitionProperty: "grid-template-rows, margin-bottom, opacity"
});

const labelSlotHiddenStyle = css({
    gridTemplateRows: "0fr",
    mb: -2,
    opacity: 0,
    pointerEvents: "none"
});

const labelTextStyle = css({
    minHeight: 0,
    overflow: "hidden"
});
import {useRef} from "react";
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";
import {
    IHomeMatchPreferencesWizardMapActions,
    useHomeMatchPreferencesWizardLocationMap
} from "../../hooks/preferences/use_home_match_preferences_wizard_location_map";
import {HomeMatchUserPreferencesLocation} from "../home_match_user_preferences/HomeMatchUserPreferencesLocation";
import {HomeMatchUserPreferencesLocationPreview} from "../home_match_user_preferences/HomeMatchUserPreferencesLocationPreview";

const {LOCATION_LABEL, LOCATION_NEXT_PLACEHOLDER, LOCATION_PLACEHOLDER} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;
const WIZARD_MAP_HEIGHT = 250;

interface IProps {
    hideLabel?: boolean;
    isMapOpen: boolean;
    onMapActiveChange: (isMapActive: boolean) => void;
    onRegisterMapActions: (actions: IHomeMatchPreferencesWizardMapActions | null) => void;
}

export const HomeMatchPreferencesWizardLocationStep = (props: IProps) => {
    const {hideLabel = false, isMapOpen, onMapActiveChange, onRegisterMapActions} = props;
    const {isMobile} = useUserDevice();
    const stepRef = useRef<HTMLDivElement>(null);
    const {coverStyle, handleUpdateRegionsByLocationPreview, openMap, regions} = useHomeMatchPreferencesWizardLocationMap({
        isMapOpen,
        onMapActiveChange,
        onRegisterMapActions,
        stepRef
    });

    return (
        <div className={cx(stepStyle, isMobile && stepMotionStyle)} ref={stepRef} style={coverStyle}>
            {!hideLabel &&
                (isMobile ? (
                    <div className={cx(labelSlotStyle, isMapOpen && labelSlotHiddenStyle)}>
                        <Text className={labelTextStyle} color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                            {LOCATION_LABEL}
                        </Text>
                    </div>
                ) : (
                    !isMapOpen && (
                        <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                            {LOCATION_LABEL}
                        </Text>
                    )
                ))}

            <HomeMatchUserPreferencesLocation
                hideIcons
                name="regions"
                nextPlaceholder={LOCATION_NEXT_PLACEHOLDER}
                onFocus={openMap}
                placeholder={LOCATION_PLACEHOLDER}
            />

            {isMapOpen && (
                <HomeMatchUserPreferencesLocationPreview
                    mapHeight={WIZARD_MAP_HEIGHT}
                    onUpdateRegions={handleUpdateRegionsByLocationPreview}
                    selectedRegions={regions}
                />
            )}
        </div>
    );
};

const coverMotion = css.raw({
    transitionDuration: "220ms",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",

    "@media (prefers-reduced-motion: reduce)": {
        transitionDuration: "0s"
    }
});

const stepStyle = css({
    backgroundColor: "var(--colors-white)",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    position: "relative",
    width: "100%",
    zIndex: "var(--zIndex-base)",

    md: {
        backgroundColor: "transparent",
        zIndex: "auto"
    }
});

const stepMotionStyle = css(coverMotion, {
    transitionProperty: "transform, margin-bottom"
});

const labelSlotStyle = css(coverMotion, {
    display: "grid",
    gridTemplateRows: "1fr",
    minHeight: 0,
    transitionProperty: "grid-template-rows, margin-bottom, opacity"
});

const labelSlotHiddenStyle = css({
    gridTemplateRows: "0fr",
    mb: -2,
    opacity: 0,
    pointerEvents: "none"
});

const labelTextStyle = css({
    minHeight: 0,
    overflow: "hidden"
});
